<template>
  <div :id="id" class="dates-selects is-flex">
    <b-field v-if="showMonth"
             :type="monthError ? 'is-danger' : ''"
             :message="monthError"
    >
      <b-dropdown
        :disabled="disabled"
        name="month"
        class="dropdown-select-normal"
        @input="selectMonth"
        @active-change="closeSelectMonth($event)"
      >
        <button slot="trigger" :class="{'has-error': monthError || hasError}" class="button">
          <span class="trimmed">{{ monthNamesTranslated[selectedMonth-1] || labels.monthPlaceholder }}</span>
          <svg-icon name="down-default" width="12" height="12"></svg-icon>
        </button>
        <b-dropdown-item
          v-for="(month, index) in Object.values(monthNamesTranslated)"
          :value="index+1"
          :key="index+1">
          <div :title="month">
            <div>{{ month }}</div>
          </div>
        </b-dropdown-item>
      </b-dropdown>

    </b-field>
    <b-field
      :type="yearError ? 'is-danger' : ''"
      :message="yearError"
      :class="{'is-single': !showMonth}"
    >
      <b-dropdown
        :disabled="disabled"
        :class="{'is-danger': yearError}"
        name="year"
        class="dropdown-select-normal"
        @input="selectYear"
        @active-change="closeSelectYear($event)"
      >
        <button slot="trigger" :class="{'has-error': yearError || hasError}" class="button">
          <span class="trimmed">{{ selectedYear || labels.yearPlaceholder }}</span>
          <svg-icon name="down-default" width="12" height="12"></svg-icon>
        </button>
        <b-dropdown-item
          v-for="year in listOfYears"
          :value="year"
          :key="year">
          <div :title="year">
            <div>{{ year }}</div>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </b-field>
  </div>
</template>

<script>

import translated from 'top20common/distribution/services/translated-data';

export default {
  props: {
    id: String,
    selectedMonth: Number,
    selectedYear: Number,
    yearError: {
      type: String,
      default: ''
    },
    showMonth: {
      default: true,
      type: Boolean
    },
    monthError: {
      type: String,
      default: ''
    },
    disabled: {
      default: false,
      type: Boolean
    },
    maxYear: {
      type: Number,
      default: new Date().getFullYear()
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    listOfYears() {
      const latestYear = this.maxYear ? this.maxYear : new Date().getFullYear();
      const arrayOfYears = [];
      for (let i = 1900; i <= latestYear; i++) {
        arrayOfYears.push(i);
      }
      return arrayOfYears.reverse();
    },
    labels() {
      return {
        monthPlaceholder: this.$gettext('Month'),
        yearPlaceholder: this.$gettext('Year')
      };
    },
    monthNamesTranslated() {
      return translated.getMonthNamesTranslated(this);
    }
  },
  methods: {
    selectMonth(value) {
      this.$emit('select-month', value);
    },
    selectYear(value) {
      this.$emit('select-year', value);
    },
    closeSelectMonth(payload) {
      if (!payload) {
        this.$emit('blur-month');
      }
    },
    closeSelectYear(payload) {
      if (!payload) {
        this.$emit('blur-year');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.field {
  width: 49%;
  .dropdown-select-normal {
    width: 100%;
    /deep/ .button {
      min-width: 100px;
      width: 100%;
    }
    /deep/ .dropdown-trigger {
      width: 100%;
    }

    .trimmed {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 85%;
    }
  }
}
.field.is-single {
  width: 100%;
}
.dates-selects {
  justify-content: space-between;
  & > :first-child {
  }
}
.form-label {
  display: block;
  margin-bottom: 5px;
}

/deep/ .svg-icon {
  stroke: var(--gray);
}
.has-error {
  border-color: var(--error);
}
</style>
